import {useState, useEffect} from 'react';

export type DeviceType = 'Android' | 'iOS' | 'Other';

/** ///////////////// Zebrar provided /////////////////  */
const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState<DeviceType>('Other');

  const getDeviceType = async () => {
    const ua = navigator.userAgent;

    // @ts-expect-error - TS doesn't know about navigator.userAgentData
    if (navigator.userAgentData) {
      try {
        // @ts-expect-error - TS doesn't know about navigator.userAgentData
        const uaData = await navigator.userAgentData.getHighEntropyValues([
          'brands',
          'platform',
          'model',
          'mobile',
        ]);

        if (uaData.mobile) {
          if (
            uaData.brands.some((brand: {brand: string}) =>
              /samsung|google|android/i.test(brand.brand),
            )
          ) {
            return 'Android';
          } else if (
            uaData.brands.some((brand: {brand: string}) =>
              /apple/i.test(brand.brand),
            )
          ) {
            return 'iOS';
          }
        }

        return 'Other';
      } catch (error) {
        return 'Other';
      }
    } else {
      if (
        (/iPad|iPhone|iPod/.test(ua) ||
          document.createElement('a').relList.supports('ar')) &&
        // @ts-expect-error - TS doesn't know about MSStream
        !window.MSStream
      ) {
        return 'iOS';
      } else if (/Android/.test(ua)) {
        return 'Android';
      }

      return 'Other';
    }
  };

  const checkARSupport = async (deviceType: DeviceType) => {
    let arCapable = false;

    if (deviceType === 'iOS') {
      // Check using the <a> element's relList for iOS
      arCapable = document.createElement('a').relList.supports('ar');

      if (arCapable === false) {
        arCapable = /CriOS/.test(navigator.userAgent); // Check if we are in Chrome on iOS
      }
    } else if (deviceType === 'Android') {
      // Check for WebXR support on Android
      arCapable = 'xr' in navigator;

      if (arCapable) {
        try {
          // @ts-expect-error - TS doesn't know about navigator.xr.isSessionSupported
          arCapable = await navigator.xr.isSessionSupported('immersive-ar');
        } catch (error) {
          console.error('Failed to check AR support on Android:', error);
          arCapable = false;
        }
      }
    }

    return arCapable;
  };

  useEffect(() => {
    const checkDeviceType = async () => {
      const detectedDeviceType = await getDeviceType();
      const arSupported = await checkARSupport(detectedDeviceType);
      const finalDeviceType = arSupported ? detectedDeviceType : 'Other';
      setDeviceType(finalDeviceType);
      console.log(finalDeviceType);
    };

    checkDeviceType();
  }, []);

  return deviceType;
};

export default useDeviceType;
